import { Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../../../types/user';

const { Option } = Select;

interface Filters {
  roleId: number | undefined | null;
  nameOrEmail: string;
}

interface FiltersComponentProps {
  filters: Filters;
  userRoles: UserRole[];
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  onApply: () => void;
  isHasRolePermission: boolean;
}

const UserManagementFilters = ({
  filters,
  setFilters,
  userRoles,
  isHasRolePermission,
  setCurrentPage,
}: FiltersComponentProps) => {
  const { t } = useTranslation('userManagement');

  const handleNameOrEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prevFilters) => ({ ...prevFilters, nameOrEmail: e.target.value }));
    setCurrentPage(1);
  };

  const handleRoleChange = (value: number) => {
    setFilters((prevFilters) => ({ ...prevFilters, roleId: value }));
    setCurrentPage(1);
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto flex-grow">
      {isHasRolePermission && (
        <Select
          placeholder={t('selectRole')}
          onChange={handleRoleChange}
          // className='w-[200px]'
          value={filters.roleId}
          allowClear
          size="middle"
          notFoundContent={t('noData')}
        >
          {userRoles.map((role) => (
            <Option key={role.id} value={role.id}>
              {t(`${role.name}`)}
            </Option>
          ))}
        </Select>
      )}
      <Input
        placeholder={t('searchByNameOrEmail')}
        onChange={handleNameOrEmailChange}
        value={filters.nameOrEmail}
        className='md:w-[300px]'
        allowClear
        size="middle"
      />
    </div>
  );
};

export default UserManagementFilters;
